module.exports = __webpack_public_path__ + "img/chongqing.eb0eaf92.png";